import Index from '@/pages/emegroup/Index'
import List from '@/pages/emegroup/List'
import Create from '@/pages/emegroup/Create'
import Import from '@/pages/emegroup/Import'
import Modify from '@/pages/emegroup/Modify'

export default {
  path: 'group',
  component: Index,  
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'create',
      component: Create
    },
    {
      path: 'import',
      component: Import
    },
    {
      path: 'modify/:id',
      component: Modify
    }
  ]
}

